import { usePersonaStore } from '../../../../../store/usePersonaStore'
import FilterChip from '../../../../portal/lesson/booking/TutorFilterControls/FilterChip'
import { intimacyItems, relationshipItems } from './content'

const Relationship = () => {
  const { relationshipId, setRelationshipId, intimacyId, setIntimacyId } = usePersonaStore()

  return (
    <div className="flex flex-col p-[20px]">
      <span className="Headline3-22Bd">나와는 어떤 관계인가요?</span>
      <div className="mt-[36px]">
        <span className="Title2-18Bd">업무 관계</span>

        <div className="flex flex-row flex-wrap gap-[8px] mt-[18px]">
          {relationshipItems.map((item) => (
            <FilterChip
              key={item.id}
              id={item.alt}
              name={item.value}
              checked={relationshipId === item.id}
              onClick={() => setRelationshipId(item.id)}
            />
          ))}
        </div>
      </div>

      <div className="mt-[36px]">
        <span className="Title2-18Bd">친밀도</span>

        <div className="flex flex-row flex-wrap gap-[8px] mt-[18px]">
          {intimacyItems.map((item) => (
            <FilterChip
              key={item.id}
              id={item.alt}
              name={item.value}
              checked={intimacyId === item.id}
              onClick={() => setIntimacyId(item.id)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
export default Relationship
